<mat-form-field appearance="outline" subscriptSizing="dynamic">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }

  <mat-select
    [ngModel]="value()"
    (ngModelChange)="onValueChange($event)"
    [disabled]="disabled()"
    [multiple]="multiple()"
    [placeholder]="placeholder()"
    [hideSingleSelectionIndicator]="true"
    [panelClass]="panelClass()"
    [attr.aria-label]="ariaLabel() || null"
    (click)="onSelectClick($event)"
    (openedChange)="onOpenedChange($event)"
  >
    <!--
      Projected content lands inside mat-select's panel, which is what puts the
      filter field in the overlay rather than next to the trigger. It is sticky
      rather than static because the panel itself is the scroll container.
    -->
    @if (searchable()) {
      <div class="bz-select-search">
        <bz-icon [icon]="searchIcon" />
        <input
          #searchField
          type="text"
          class="bz-select-search__field"
          autocomplete="off"
          [placeholder]="searchPlaceholder()"
          [attr.aria-label]="searchPlaceholder()"
          [value]="query()"
          (input)="onSearchInput($event)"
          (keydown)="onSearchKeydown($event)"
        />
      </div>
    }

    @for (run of visibleRuns(); track $index) {
      @if (run.label) {
        <mat-optgroup [label]="run.label">
          @for (option of run.options; track option.value) {
            <mat-option [value]="option.value" [disabled]="!!option.disabled">
              <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ $implicit: option }" />
            </mat-option>
          }
        </mat-optgroup>
      } @else {
        @for (option of run.options; track option.value) {
          <mat-option [value]="option.value" [disabled]="!!option.disabled">
            <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ $implicit: option }" />
          </mat-option>
        }
      }
    } @empty {
      @if (searchable()) {
        <p class="bz-select-empty" role="status">{{ noResultsLabel() }}</p>
      }
    }
  </mat-select>
</mat-form-field>

<!--
  One row body for both the grouped and the loose branch. Inlining it twice is
  how it drifts: the two copies are edited months apart.
-->
<ng-template #row let-option>
  <span class="bz-select-row">
    <span class="bz-select-row__lead">
      @if (option.icon) {
        <bz-icon [icon]="option.icon" />
      }
      <span class="bz-select-row__label">{{ option.label }}</span>
    </span>

    @if (option.hint || option.trailingIcon) {
      <span class="bz-select-row__trail">
        @if (option.hint) {
          <span class="bz-select-row__hint">{{ option.hint }}</span>
        }
        @if (option.trailingIcon) {
          <bz-icon [icon]="option.trailingIcon" />
        }
      </span>
    }
  </span>
</ng-template>
